module.exports = __webpack_public_path__ + "static/media/battleship.cc9c1d52.png";